<template>
    <v-app class="pa-0">
        <headerPlan 
            :appUserInfo="appUserInfo"
        />
        <v-container
            :class="{ 'pa-0 py-7 body': !isMobile && !isTablet, 'body-resp': isMobile || isTablet}"
        >
            <v-card-text
                class="pa-0 text-h4"
                :class="{ 'mt-3': isMobile || isTablet }"
            >
                {{ $t('confirm-and-pay') }}
            </v-card-text>

            <v-container
                class="d-flex align-center gap-4 pa-0"
                :class="{ 'flex-column': isMobile || isTablet }"
            >
                <v-container
                    class="pa-0 flex-fill d-flex flex-column"
                    :style="{'width': !isMobile && !isTablet ? '50%' : '100%', 'height': !isMobile && !isTablet ? '498px' : '' }"
                >
                    <v-card
                        v-if="userCurrentPlan != null && userCurrentPlan != undefined"
                        class="mb-0"
                        :class="{ 'pa-7': !isMobile && !isTablet, 'pa-3': isMobile || isTablet }"
                    >
                        <v-container class="pa-0 d-flex justify-space-between">
                            <v-card-text class="pa-0 text-body-2">
                                {{ $t('current-subscription') }}
                            </v-card-text>
                            <div class="d-flex gap-1 align-center">
                                <img :src="userCurrentPlan.plan.icon" style="width: 20px;" />
                                <v-card-text class="pa-0 text-body-2">{{ userCurrentPlan.plan.name }}</v-card-text>
                            </div>
                        </v-container>
                        <v-container class="pa-0 d-flex justify-space-between mt-3">
                            <v-card-text class="pa-0 text-body-2">
                                {{ $t('current-plan-expire-date') }}
                            </v-card-text>
                            <v-card-text class="pa-0 text-body-2">
                                {{ userCurrentPlan.ends_at }}
                            </v-card-text>
                        </v-container>
                        <v-container class="pa-0 d-flex justify-space-between mt-3">
                            <v-card-text class="pa-0 text-body-2">
                                {{ $t('exist-sms-count') }}
                            </v-card-text>
                            <v-card-text class="pa-0 text-body-2">
                                {{ smsCountRemain? smsCountRemain : '' }}
                            </v-card-text>
                        </v-container>
                    </v-card>
                    <v-card
                        v-if="plan != undefined && plan != null"
                        class="mb-0 pb-0"
                        :class="{ 'pa-7 mt-4': !isMobile && !isTablet, 'pa-3 mb-3 mt-3': isMobile || isTablet }"
                        :style="{
                            'border-bottom': !isMobile && !isTablet ? 'none' : '',
                            'border-bottom-left-radius': !isMobile && !isTablet ? '0 !important' : '',
                            'border-bottom-right-radius': !isMobile && !isTablet ? '0 !important' : ''
                        }"
                    >
                        <v-container class="d-flex align-center justify-space-between pa-0 mb-5">
                            <v-card-text class="pa-0 text-body-1">{{ $t('cart') }}</v-card-text>
                        </v-container>
                        <v-container
                            class="d-flex align-center justify-space-between pa-0 my-6"
                            :class="{ 'mb-3': isMobile || isTablet }"
                        >
                            <div class="text-center">
                                <img
                                    :src="plan.icon" 
                                    style="width: 50px;"
                                />
                                <v-card-text class="pa-0 text-body-2">{{ plan.name }}</v-card-text>
                            </div>
                            <div>
                                <v-card-text class="pa-0 text-h4 d-flex justify-end mb-3">
                                    {{ 
                                        plan.origin_price == 0 ? $t('checkoutAddonFree') : 
                                        plan.origin_price < 0 ? $t('contactus') : 
                                        plan.origin_price > 0 ? $numberFormat(plan.origin_price) + ' ' + $t('rial') : ''
                                    }}
                                </v-card-text>
                                <v-card-text class="pa-0 text-h4 d-flex justify-end">{{ $t('validity-period') }}</v-card-text>
                                <v-card-text class="pa-0 text-caption mt-1 d-flex justify-end">
                                    {{ plan.duration }}
                                    {{ $t('days') }} {{ $t('until') }} {{ $t('date') }}
                                    {{ resolvePlanExpireDate(plan) }}
                                </v-card-text>
                            </div>
                        </v-container>
                    </v-card>
                    <v-card
                        class="mt-0"
                        :class="{ 'pt-0 pa-7 ': !isMobile && !isTablet, 'pa-3': isMobile || isTablet, 'mt-3 pt-7': !isMobile && !isTablet && $route.query.chargingSMS }"
                        :style="{
                            'border-top': !isMobile && !isTablet && !$route.query.chargingSMS ? 'none' : '1px solid #c0c0c07d',
                            'border-top-left-radius': !isMobile && !isTablet && !$route.query.chargingSMS ? '0 !important' : '4px',
                            'border-top-right-radius': !isMobile && !isTablet && !$route.query.chargingSMS ? '0 !important' : '4px'
                        }"
                    >
                        <v-container 
                            v-if="isUserChargingSMS"
                            class="d-flex align-center gap-3 pa-0 mb-6"
                        >
                            <v-btn
                                color="secondary"
                                outlined
                                style="width: auto;height: 30px;padding: 0 !important;min-width: 35px;"
                                @click="increaseSMSCount"
                            >
                                <v-icon size="15">mdi-plus</v-icon>
                            </v-btn>
                            <v-card-text class="pa-0 text-body-2">
                                {{ smsCount }}
                            </v-card-text>
                            <v-btn
                                color="secondary"
                                outlined
                                style="width: auto;height: 30px;padding: 0 !important;min-width: 35px;"
                                @click="decreaseSMSCount"
                            >
                                <v-icon size="15">mdi-minus</v-icon>
                            </v-btn>
                        </v-container>
                        <v-container
                            class="d-flex align-center justify-space-between pa-0 mb-5 gap-3"
                        >
                            <div class="d-flex align-center gap-1">
                                <v-card-text class="pa-0 text-body-2">{{ smsCount }}</v-card-text>
                                <v-card-text class="pa-0 text-body-2">{{ $t('sms-count') }}</v-card-text>
                            </div>
                            <v-card-text class="pa-0 text-body-2">{{ $numberFormat(totalPriceSMS) }} ریال</v-card-text>
                        </v-container>
                        <v-card-text class="pa-0 text-body-2">{{ $t('suggestion') }}</v-card-text>
                        <v-container class="pa-0 d-flex align-center gap-2 mt-3">
                            <div 
                                v-for="(sms, index) in smsOrders"
                                :key="index"
                                class="box flex-fill"
                                @click="selectOrderSms(sms)"
                            >
                                <v-card-text class="pa-0 text-h5">
                                    <v-icon size="19" class="mb-1">mdi-plus</v-icon>
                                    {{ sms.sms_count }} {{ $t('sms') }}
                                </v-card-text>
                                <v-card-text class="pa-0 text-body-2 mt-1">
                                {{ $numberFormat(sms.price) }} ریال
                                </v-card-text>
                            </div>
                        </v-container>
                    </v-card>
                </v-container>
                <v-container
                    class="pa-0 flex-fill d-flex flex-column"
                    :style="{'width': !isMobile && !isTablet ? '50%' : '100%', 'height': !isMobile && !isTablet ? '498px' : ''}"
                >
                    <v-card
                        class="mb-0"
                        :class="{ 'pa-7 pb-0': !isMobile && !isTablet, 'pa-3 mb-3': isMobile || isTablet }"
                        :style="{
                            'border-bottom': !isMobile && !isTablet ? 'none' : '',
                            'border-bottom-left-radius': !isMobile && !isTablet ? '0 !important' : '',
                            'border-bottom-right-radius': !isMobile && !isTablet ? '0 !important' : ''
                        }"
                    >
                        <v-container class="pa-0 d-flex gap-2">
                            <v-text-field
                                v-model="discountCode"
                                outlined
                                clearable
                                dense
                                :label="$t('discount-Code')"
                                height="30"
                                :disabled="isUserChargingSMS"
                            />
                            <v-btn
                                outlined
                                color="secondary"
                                height="34"
                                @click="performDiscount"
                                :disabled="isUserChargingSMS || discountCode == null"
                            >
                            {{ $t('apply-discount') }}
                            </v-btn>
                        </v-container>
                    </v-card>
                    <v-card
                        class="mt-0"
                        :class="{ 'pt-0 pa-7 mb-0 pb-0': !isMobile && !isTablet, 'pa-3 py-0': isMobile || isTablet }"
                        :style="{
                            'border-top': !isMobile && !isTablet ? 'none' : '',
                            'border-bottom': !isMobile && !isTablet ? 'none' : '',
                            'border-radius': !isMobile && !isTablet ? '0 !important' : ''
                        }"
                    >
                        <v-container class="pa-0 d-flex justify-space-between mt-5">
                            <v-card-text class="pa-0 text-body-2">{{ $t('total-invoice') }}</v-card-text>
                            <v-card-text class="pa-0 text-body-2">{{ $numberFormat(total) || 0 }} {{ $t('rial') }}</v-card-text>
                        </v-container>
                        <v-container class="pa-0 d-flex justify-space-between mt-3">
                            <v-card-text class="pa-0 text-body-2">{{ $t('discount') }}</v-card-text>
                            <v-card-text class="pa-0 text-body-2">{{ $numberFormat(discount) || 0 }} {{ $t('rial') }}</v-card-text>
                        </v-container>
                        <v-container class="pa-0 d-flex justify-space-between mt-3">
                            <v-card-text class="pa-0 text-body-2">{{ $t('checkoutVAT') }}</v-card-text>
                            <v-card-text class="pa-0 text-body-2">{{ isUserChargingSMS ? $numberFormat(tax) : $numberFormat(resolveTax) }} {{ $t('rial') }}</v-card-text>
                        </v-container>
                        <v-container 
                            v-if="!$route.query.isUserRenewPlan && !$route.query.chargingSMS"
                            class="pa-0 d-flex justify-space-between mt-3"
                        >
                            <v-card-text class="pa-0 text-body-2">{{ $t('current-plan-remain') }}</v-card-text>
                            <v-card-text class="pa-0 text-body-2">{{ resolveCurrentPlanRemain() }} {{ $t('rial') }}</v-card-text>
                        </v-container>
                        <v-container class="pa-0 d-flex justify-space-between mt-3">
                            <v-card-text class="pa-0 text-body-2">{{ $t('amountForPay') }}</v-card-text>
                            <v-card-text class="pa-0 text-body-2">
                                {{ 
                                    (isUserChargingSMS && !isUserHasRemainFromCurrentPlan) ? $numberFormat(amountForPaySMS) + ' ' + $t('rial') : 
                                    (!isUserChargingSMS && !isUserHasRemainFromCurrentPlan) ? $numberFormat(resolveTotalInvoice) + ' ' + $t('rial') : 
                                    (!isUserChargingSMS && isUserHasRemainFromCurrentPlan) ? $numberFormat(resolveTotalInvoiceWithRemainPlan) + ' ' + $t('rial') : ''
                                }}
                            </v-card-text>
                        </v-container>
                        <v-card-text class="pa-0 text-body-2 text-center px-16 mt-8">
                            {{ $t('privacy policy') }}
                        </v-card-text>
                    </v-card>
                    <v-card
                        class="mt-0"
                        :class="{ 'pt-0 pa-7': !isMobile && !isTablet, 'pa-0': isMobile || isTablet }"
                        :style="{
                            'border-top': !isMobile && !isTablet ? 'none' : '',
                            'border-top-left-radius': !isMobile && !isTablet ? '0 !important' : '',
                            'border-top-right-radius': !isMobile && !isTablet ? '0 !important' : ''
                        }"
                    >
                        <v-btn
                            color="success"
                            class="w-100"
                            :loading="loading"
                            :class="{ 'mt-5': !isMobile && !isTablet }"
                            @click="submit"
                        >
                        {{ $t('payment') }}
                        </v-btn>
                    </v-card>
                </v-container>
            </v-container>
        </v-container>
        <footerPlan />
        <v-snackbar
        v-model="snakbar"
        :color="(snakbarColor ? snakbarColor : 'primary')"
        top
        style="z-index: 1000000000000 !important;"
        >
        {{ snakbarText }}

        <template v-slot:action="{ attrs }">
            <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snakbar = !snakbar"
            >
            {{ $t('close') }}
            </v-btn>
        </template>
        </v-snackbar>
    </v-app>
</template>

<script>
import headerPlan from '@/views/dashboard/pages/plans/partial/headerPlan.vue'
import footerPlan from '@/views/dashboard/pages/plans/partial/footerPlan.vue'
import General from '@/Mixins/mixin.js'
import moment from 'moment-jalaali'
import { mapState } from 'vuex'
import { numberFormat } from 'highcharts'
import { count } from '@progress/kendo-data-query/dist/npm/array.operators'
import { load } from '@progress/kendo-vue-intl'

export default {
  mixins: [General],
  data () {
    return {
        plan: null,
        discountCode: null,
        smsOrders: null,
        userInfo: null,
        totalPriceSMS: null,
        smsCount: 0,
        isUserSelectSms: false,
        discount: 0,
        total: 0,
        planPrice: null,
        tokenUserApp: null,
        appUserInfo: null,
        isUserChargingSMS: false,
        tax: 0,
        amountForPaySMS: 0,
        snakbarText: null,
        snakbarColor: null,
        snakbar: false,
        today: null,
        isUserHasRemainFromCurrentPlan: false,
        userRemainFromCurrentPlan: 0,
        loading: false,
        userNotFound: false
    }
  },
  components: {
    headerPlan,
    footerPlan
  },
  computed: {
    resolveTax () {
        const total = Number(this.total)
        const discount = Number(this.discount)
        return (total - discount) * 0.10
    },
    resolveTotalInvoice () {
        const total = Number(this.total)
        const discount = Number(this.discount)
        const tax = Number(this.resolveTax)
        return (total - discount) + tax
    },
    resolveTotalInvoiceWithRemainPlan () {
        const total = Number(this.total)
        const discount = Number(this.discount)
        const tax = Number(this.resolveTax)
        return ((total - discount) + tax) - Number(this.userRemainFromCurrentPlan)
    },
    ...mapState(['userCurrentPlan', 'smsCountRemain'])
  },
  mounted () {
    if (this.$route.query.chargingSMS) {
        this.isUserChargingSMS = true
    } else {
        this.plan = this.$route.query.plan
        this.resolveTotal()
        this.resolvePlanDiscount()
    }

    this.userInfo = JSON.parse(localStorage.getItem('token'))
    this.fetchSmsOrders()
    if (this.$route.query.token) {
      this.tokenUserApp = this.$route.query.token
      if (this.tokenUserApp) {
        this.getServiceInfo()
      }
    }
    
  },
  methods: {
    resolveTotal () {
        this.total = Number(this.plan.origin_price)
    },
    resolvePlanDiscount () {
        if (this.plan.has_coupon && this.discounted != 0) {
            this.discount = 0
        } else {
            this.discount = Number(this.plan.origin_price * this.plan.discounted / 100)
        }
    },
    performDiscount () {
      var app = this
      delete this.$axios.defaults.headers.common.domain
      const endpoint = 'https://plans.abriron.com/api/'
      app.$axios.get(endpoint + 'coupon/show', {
        headers: {
          'X-API-KEY': 'ZEBQXqT6fYykTWRh9zhqJCBTtXfM1MXTmjIcYHw',
          abr: this.userInfo?.init?.appBarsOpacity?.abr
        },
        params: {
            code: this.discountCode,
            amount: Number(this.plan.origin_price)
        }
      })
        .then(r => {
          this.discount = r.data.discounted_amount
        })
        .catch(err => {
            if (err.response && (err.response.status == 500)) {
                this.snakbarText = this.$t("selected item doesn't have due date")
                this.snakbarColor = 'red'
                this.snakbar = true
            }
            this.serverErrorHandeler(err)
        })
        .finally(() => {
            this.isLoading = false
        })
    },
    fetchSmsOrders () {
      var app = this
      delete this.$axios.defaults.headers.common.domain
      const endpoint = 'https://plans.abriron.com/api/'
      app.$axios.get(endpoint + 'sms', {
        headers: {
          'X-API-KEY': 'ZEBQXqT6fYykTWRh9zhqJCBTtXfM1MXTmjIcYHw',
          abr: this.userInfo?.init?.appBarsOpacity?.abr
        }
      })
        .then(r => {
          this.smsOrders = r.data
        })
    },
    selectOrderSms (value) {
        this.isUserSelectSms = true
        this.totalPriceSMS += value.price
        this.smsCount += value.sms_count

        if (!this.isUserChargingSMS) {
            const current = Number(this.total)
            const add = Number(value.price)
            const sum = current + add
            this.total = Number(sum)
        } else {
            this.total = Number(this.totalPriceSMS)
        }
    },
    submit() {
        if (this.userNotFound) {
            this.snakbarText = this.$t("your account is deactive")
            this.snakbarColor = 'red'
            this.snakbar = true
        } else {
            if (!this.isUserChargingSMS) {
                this.loading = true
                delete this.$axios.defaults.headers.common.domain
                const endpoint = 'https://plans.abriron.com/api/'
                this.$axios.post(endpoint + 'subscription/store',
                    {
                        plan_id: (this.plan && this.plan.id) ? this.plan.id : null,
                        gateway: this.$route.query.gateway ? this.$route.query.gateway : 'zarinpal',
                        plan_duration_id: this.plan ? this.plan.duration_id : null,
                        coupon: this.discountCode,
                        sms_count: this.smsCount
                    },
                    {
                        headers: {
                            'X-API-KEY': 'ZEBQXqT6fYykTWRh9zhqJCBTtXfM1MXTmjIcYHw',
                            abr: (this.appUserInfo && this.appUserInfo.abr) ? this.appUserInfo.abr : this.userInfo?.init?.appBarsOpacity?.abr,
                            'Mobile-Application': this.appUserInfo != null ? 'android' : 'web'
                        }
                    }
                )
                .then(r => {
                    if (r.data) {
                        window.location.href = r.data
                        this.loading = false
                    }
                })
                .catch(err => {
                    if (err.response && (err.response.status == 422 || err.response.status == 403)) {
                        this.snakbarText = this.$t("can't change to lower plan")
                        this.snakbarColor = 'red'
                        this.snakbar = true
                    }
                    this.serverErrorHandeler(err)
                })
                .finally(() => {
                    this.isLoading = false
                })
            } else {
                const endpoint = 'https://plans.abriron.com/api/'
                this.isLoading = true
                delete this.$axios.defaults.headers.common.domain
                this.$axios.post(endpoint + 'sms/pay',
                    {
                        gateway: this.$route.query.gateway ? this.$route.query.gateway : 'zarinpal',
                        sms_count: this.smsCount
                    },
                    {
                        headers: {
                            'X-API-KEY': 'ZEBQXqT6fYykTWRh9zhqJCBTtXfM1MXTmjIcYHw',
                            abr: (this.appUserInfo && this.appUserInfo.abr) ? this.appUserInfo.abr : this.userInfo?.init?.appBarsOpacity?.abr,
                            'Mobile-Application': this.appUserInfo != null ? 'android' : 'web'
                        }
                    }
                )
                .then(r => {
                    if (r.data) {
                        window.location.href = r.data
                        this.isLoading = false
                    }
                })
                .catch(err => {
                    if (err.response && (err.response.status == 422 || err.response.status == 403)) {
                        this.snakbarText = this.$t("can't change to lower plan")
                        this.snakbarColor = 'red'
                        this.snakbar = true
                    }
                    this.serverErrorHandeler(err)
                })
                .finally(() => {
                    this.isLoading = false
                })
            }
        }
    },
    getServiceInfo () {
      var app = this
      app.loading = true
      delete this.$axios.defaults.headers.common.domain
      app.$axios.get(this.$endpoint + 'getdetail', {
        headers: {
          Authorization: 'Bearer ' + this.tokenUserApp,
          'mobile-application': 'android'
        },
        params: {
          select: 'getServiceInfo',
          search: null,
          page: 1
        }
      })
        .then(r => {
          this.appUserInfo = r.data
          if (this.appUserInfo) {
            localStorage.setItem('APP_KEY', this.appUserInfo.appKey)
          }
        })
        .catch(err => {
            if (err.response) {
                this.userNotFound = true
            }
            this.serverErrorHandeler(err)
        })
        .finally(() => {
          app.loading = false
        })
    },
    resolvePlanExpireDate (item) {
        if (this.userCurrentPlan) {
            const today = moment().format('jYYYY/jMM/jDD')
            const endsAt = this.userCurrentPlan ? this.userCurrentPlan.ends_at : null

            const todayMoment = moment(today, 'jYYYY/jMM/jDD')
            const endsAtMoment = moment(endsAt, 'jYYYY/jMM/jDD')

            const diffDays = endsAtMoment.diff(todayMoment, 'days')

            //  تمدید
            if (this.$route.query.isUserRenewPlan) {
                const result = moment(endsAt, 'jYYYY/jMM/jDD').add(item.duration, 'days')
                const newDate = result.format('jYYYY/jMM/jDD')
                return newDate
            } else {
                // ارتقا
                const result = moment(today, 'jYYYY/jMM/jDD').add(item.duration, 'days')
                const newDate = result.format('jYYYY/jMM/jDD')
                return newDate
            }
        } else {
            this.$router.push({ name: 'Dashboard' })
        }
    },
    resolveCurrentPlanRemain () {
        // ارتقا
        if (!this.$route.query.isUserRenewPlan) {
            const today = moment().format('jYYYY/jMM/jDD')
            const endsAt = this.userCurrentPlan.ends_at 

            const todayMoment = moment(today, 'jYYYY/jMM/jDD')
            const endsAtMoment = moment(endsAt, 'jYYYY/jMM/jDD')

            const diffDays = endsAtMoment.diff(todayMoment, 'days')

            const start = moment(this.userCurrentPlan.starts_at, 'jYYYY/jMM/jDD')
            const end = moment(this.userCurrentPlan.ends_at, 'jYYYY/jMM/jDD')
            const totalDays = end.diff(start, 'days')

            if (totalDays >= diffDays) {
                if (diffDays <= 5) {
                    return 0
                }
                if (diffDays > 5) {
                    this.isUserHasRemainFromCurrentPlan = true
                    this.userRemainFromCurrentPlan = diffDays * (this.userCurrentPlan.price / totalDays)
                    return this.$numberFormat(diffDays * (this.userCurrentPlan.price / totalDays))
                }
            }  else {
                return 0
            }

        }
    },
    increaseSMSCount () {
        this.smsCount += 100
        this.totalPriceSMS += 500000
        if (!this.isUserChargingSMS) {
            const current = Number(this.total)
            const add = Number(this.totalPriceSMS)
            const sum = current + add
            this.total = Number(sum)
        } else {
            this.total = Number(this.totalPriceSMS)
        }
    },
    decreaseSMSCount () {
        if (this.smsCount != 0) {
            this.smsCount -= 100
            this.totalPriceSMS -= 500000
            if (!this.isUserChargingSMS) {
                const current = Number(this.total)
                const add = Number(this.totalPriceSMS)
                const sum = current + add
                this.total = Number(sum)
            } else {
                this.total = Number(this.totalPriceSMS)
            }
        }
    }
  },
  watch: {
    total (val) {
        if (val && this.isUserChargingSMS) {
            const total = Number(val)
            const discount = Number(this.discount)
            this.tax = Number((total - discount) * 0.10)
            this.amountForPaySMS = Number((total - discount) + this.tax)
        }
    },
    discountCode (val) {
        if (val == null) {
            this.discount = 0
        }
    },
    totalPriceSMS (val) {
        if (val == 0 && this.isUserChargingSMS) {
            this.total = 0
            this.discount = 0
            this.tax = 0
            this.amountForPaySMS = 0
        }
    }
  }
}
</script>

<style scoped>
.body {
  padding-right: 150px !important;
  padding-left: 150px !important;
  background-color: #f3f3f3;
  height: 100%;
}
.body-resp {
    background-color: #f3f3f3;
}
.v-card__text {
    width: auto;
}
.box {
    border: 1px solid silver;
    border-radius: 4px;
    padding: 12px;
    text-align: center;
    cursor: pointer;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
    border: 1px solid #c0c0c07d;
}
</style>
